// extracted by mini-css-extract-plugin
module.exports = {"dialog":"Dialog_dialog__V82aL","content":"Dialog_content__sxJ6M"};